import type { FaireProductEntity } from "../../entity_types/product";

export const p_uc7cpdeqra: FaireProductEntity = {
  token: "p_uc7cpdeqra",
  type: "product",
  name: "World's Best Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/761e8c843a2302036cf959a3baf72646eb7f230eedf3f62eefaf57df3197c57c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/64b2643977aa6a00229117e7082cb72d0dd744ab4807d76c24b51d6bdcc7390e.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:24.326Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
